import { render, staticRenderFns } from "./TriviaEmptyState.vue?vue&type=template&id=382f22f6&"
import script from "./TriviaEmptyState.vue?vue&type=script&lang=js&"
export * from "./TriviaEmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports